import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from '../utility/Dropdown';
import TripItem from '../Home/TripItem';
import NewTripItem from '../Home/NewTripItem';
import TripPopUp from '../Home/TripPopUp';
import Stories from '../Home/Stories';
import TileStories from '../Home/TileStories';
import BannerCarousel from '../Home/BannerCarousel';
import Button from '../utility/Button';
import ErrorDisplay from '../utility/ErrorDisplay';
import { languages as lg } from '../../constants';
import PropTypes from 'prop-types';
import LoadingSpinner from '../utility/LoadingSpinner';
import LottieLoader from '../utility/LottieLoader';
import PriceNotes from '../utility/PriceNotes';
import { Helmet } from 'react-helmet';
import FeaturedPromo from '../Home/FeaturedPromo';
import i18n from 'i18next';
import Cookies from 'universal-cookie';
import { withTranslation } from 'react-i18next';

import { getRandomInt } from '../../js/utility';

import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';

import fordLogoWhite from '../../images/fga_logo_white.png';
import landingIcon from '../../images/img_landing_icon_v2.png';
import landingIconMobile from '../../images/img_landing_icon_mobile_v2.png';

import downArrowIcon from '../../images/icons/NewArrow.png';
import rightArrowIcon from '../../images/icons/right-arrow.png';
// import stepBanner from '../../images/Booking-steps.jpg';
// import mobileStepBanner from '../../images/MobileBooking-steps.jpg';
import stepBanner from '../../images/Booking_Steps_Banner.jpg';
import mobileStepBanner from '../../images/Booking_Steps_Banner_Mobile.jpg';
import step1 from '../../images/CategoryButton.png';
import step2 from '../../images/SortButton.png';
import step3 from '../../images/step3.png';
import beachGrey from '../../images/icons/sea_grey.png';
import beachWhite from '../../images/icons/sea_white.png';
import cityGrey from '../../images/icons/hidden_grey.png';
import cityWhite from '../../images/icons/hidden_white.png';
import jungleGrey from '../../images/icons/family_grey.png';
import jungleWhite from '../../images/icons/family_white.png';
import racingGrey from '../../images/icons/off_road_grey.png';
import racingWhite from '../../images/icons/off_road_white.png';
import foodGrey from '../../images/icons/historical_grey.png';
import foodWhite from '../../images/icons/historical_white.png';

import smallArrowUp from '../../images/icons/smallArrowUp.png';
import smallArrowDown from '../../images/icons/smallArrowDown.png';

import iconNewFB from '../../images/icons/fbSocial.png';
import iconNewIG from '../../images/icons/igSocial.png';
import iconNewYT from '../../images/icons/ytSocial.png';
import iconNewTW from '../../images/icons/xSocial.png';

import LTRLBackground_mobile from '../../images/LTRL banner mobile v2.0.jpg';
import LTRLBackground_tablet from '../../images/LTRLBackground_tablet.png';
import LTRLBackground_desktop from '../../images/LTRL banner desktop v2.0.jpg';


import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {
  fetchTrips,
  fetchAdditionalTrips,
  toggleActiveTripPopUp,
  toggleShowAllTrips,
  setSortFilter
} from '../../actions/trip';

import {
  fetchPastExperiences
} from '../../actions/pastExperiences';

import { resetSelectByor } from '../../actions/tripDetails';

import { setLightboxVideo, toggleLightbox } from '../../actions/lightbox';

import { clearApiError } from '../../actions/api';

import {
  INITIAL_TRIPS_TO_SHOW as initialTripsToShow,
  sortFilters,
  vehicleFilters,
  SITE_TITLE
} from '../../constants';

import VehicleFilter from '../Home/VehicleFilter';

const maxVideos = parseInt(process.env.COVER_VIDEO_NUM);
let videoArr = [];
for (let i = 1; i < maxVideos + 1; i++) {
  videoArr.push(`/videos/fordVideo${i === 1 ? '' : i}.mp4`);
}

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blank: false,
      themeList: null,
      selectedTheme: null,
      showAllTrips: false,
      isShowMenu: false,
      isTripTileFocus: false
    };
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.getTripsByTheme = this.getTripsByTheme.bind(this);
    this.getThemeIcon = this.getThemeIcon.bind(this);
    this.checkCurrentFilter = this.checkCurrentFilter.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.handleChildClick = this.handleChildClick.bind(this);
    this.handleThemeClick = this.handleThemeClick.bind(this);
    this.sliderPause = this.sliderPause.bind(this);
    this.sliderPlay = this.sliderPlay.bind(this);
    this.styleBackup = '';
    this.restOfTimeout = 500;
    this.currentState = '';
    this.freeze = false;
    this.isSliderInitial = false;
    this.isSliderRendered = false;
    this.slider = React.createRef();
  }

  componentDidMount() {
    this.props.clearApiError();
    // this.props.resetSelectByor();
    this.props.toggleActiveTripPopUp(false);
    if (this.props.trips.length < 1) {
      this.props.fetchTrips();
    }
    if (this.props.pastExperiences.length < 1) {
      this.props.fetchPastExperiences();
    }
    if (this.props.redirect) {
      this.setState({ blank: true });
    }
  }

  componentDidUpdate() {
    const cookies = new Cookies();
    if (
      (this.props.authType === 'Google' ||
        this.props.authType === 'Facebook') &&
      cookies.get('sdacford_site_url')
    ) {
      // console.log('Home/index.js');
      var uri = cookies.get('sdacford_site_url');
      cookies.remove('sdacford_site_url', {
        domain: '.' + process.env.DOMAIN_NAME,
        path: '/',
        secure: true
      });
      this.setState({ blank: true });
      window.location.replace(uri);
    }
  }


  toggleFilter() {
    this.setState({isShowMenu: !(this.state.isShowMenu)});
  }

  sliderPause(){
    this.styleBackup = this.slider.innerSlider.track.node.getAttribute('style');
    this.currentState = window.getComputedStyle(this.slider.innerSlider.track.node).getPropertyValue('transform');
    this.freeze = true;
    this.slider.slickPause();
    let translateDone = parseFloat(this.currentState.split(',')[4])*(-1);
    let regex = /translate3d\(([^,]*),/gm;
    let m;
    if((m = regex.exec(this.styleBackup)) !== null) {
      let translateNeed = parseFloat(m[1])*(-1);
      let slideWidth = parseInt(window.getComputedStyle(this.slider.innerSlider.track.node.firstChild).getPropertyValue('width'), 10);
      let speed = 5000/slideWidth;
      this.restOfTimeout = (translateNeed-translateDone)*speed;
    } else {
      this.restOfTimeout = 500;
    }
    this.slider.innerSlider.track.node.style.transform = this.currentState;
  }

  sliderPlay(){
    this.freeze = false;
    this.slider.innerSlider.track.node.setAttribute('style', this.styleBackup.replace('5000ms', this.restOfTimeout+'ms'));
    this.slider.slickPlay();
  }

  handleThemeClick(i){
    this.themeScrollDOM.scrollTo({
      top: 0,
      left: this['themeDOM'+i].offsetLeft,
      behavior: 'smooth'
    });
  }

  handleChildClick(e) {
    e.stopPropagation();
    this.buttonDOM.focus();
  }

  handleChangeFilter(val, theme) {
    this.buttonDOM.focus();
    const tempThemeList = this.state.themeList;
    for (const item of tempThemeList){
      if (item.theme === theme){
        const sortFilter = sortFilters.find(filter => filter.name === val);
        item.sortFilter = sortFilter;

        // Apply selected filter
        if (item.sortFilter.sortFunc) {
          item.trips = item.trips.sort(item.sortFilter.sortFunc);
        }
        this.props.setSortFilter(sortFilter);
      }
    }

    // Save new trips into themeList
    this.setState({ themeList: tempThemeList });
  }

  handleVideoButtonClick() {
    // this.props.setLightboxVideo(
    //   `/videos/ford_full_${i18n.language || i18n.languages[0]}.mp4`,
    //   false
    // );
    this.props.setLightboxVideo(
      'https://www.youtube.com/embed/Iv_uYPBicMI',
      true
    );
    this.props.toggleLightbox(true, true);
  }

  checkCurrentFilter(filterName){
    if ((this.state.themeList || []).length > 0){
      if (this.state.themeList.find(theme => theme.theme === this.state.selectedTheme)){
        return (this.state.themeList.find(theme => theme.theme === this.state.selectedTheme).sortFilter.name === filterName);
      }
    }
    return false;
  }

  getTripsByTheme(theme, trips){
    const newTrips = [];
    for (const trip of trips){
      if (trip.theme === theme){
        newTrips.push(trip);
      }
    }
    return newTrips;
  }

  getThemeIcon(theme, selectedTheme){
    /* eslint-disable no-unused-vars */
    const beach1 = beachGrey;
    const beach2 = beachWhite;
    const city1 = cityGrey;
    const city2 = cityWhite;
    const jungle1 = jungleGrey;
    const jungle2 = jungleWhite;
    const racing1 = racingGrey;
    const racing2 = racingWhite;
    const food1 = foodGrey;
    const food2 = foodWhite;
    /* eslint-enable no-unused-vars */
    return eval(theme+((theme === selectedTheme)? '2' : '1'));
  }

  render() {
    const {
      trips,
      tripsLoading,
      tripsLoadingMore,
      pastExperiences,
      error,
      vehicleFilter,
      showPopUp,
      showAllTrips,
      toggleShowAllTrips,
      sortFilter,
      hasBYOR,
      t
    } = this.props;
    const { blank } = this.state;

    // dummy pastExperiences
    // let dummyPastExperiences = [
    //   {
    //     'url': 'http://localhost:3000/getaways/trips/off-roading-durian-adventure/',
    //     'is_new': false,
    //     'img_url': {
    //       'desktop': 'https://shopstg.sdacford.com.my/images/past-experience/fnjw3frbo.jpeg',
    //       'mobile': 'https://shopstg.sdacford.com.my/images/past-experience/tx1bhj055.jpeg'
    //     }
    //   }
    // ];

    // Setting default slick-slider moving behavior
    if (this.isSliderInitial && !this.isSliderRendered){
      this.observer = new MutationObserver(function(mutationsList){
        for(const mutation of mutationsList) {
          if (mutation.type === 'attributes' &&  mutation.attributeName == 'style' && this.freeze) {
            this.slider.innerSlider.track.node.style.transform = this.currentState;
          }
        }
      });
      this.observer.observe(this.slider.innerSlider.track.node, { attributes: true });
      this.isSliderRendered = true;
    }

    // Get all vehicles model-subtext pair
    const vehicles = trips.reduce((ret, { recommended_vehicle }) => {
      const { model, subtext } = recommended_vehicle;
      if (model && !ret[model]) {
        ret[model] = subtext;
      }
      return ret;
    }, {});

    // Get list of trips
    // let tripsToShow =
    //   showAllTrips || trips.length <= initialTripsToShow
    //     ? [...trips]
    //     : trips.slice(0, initialTripsToShow);
    let tripsToShow = [...trips];

    // filter past experience from available trips
    tripsToShow = tripsToShow.filter(function(trip)
    {
      return !trip.display_exp;
    });

    // convert date_available string to array
    tripsToShow.map((trip) => {
      if (trip.date_available === '[""]'){
        trip.date_available = null;
      }
      if (typeof trip.date_available === 'string' || trip.date_available instanceof String){
        trip.date_available = JSON.parse(trip.date_available);
      }
    });

    // Process Trips for first time
    if (!this.state.themeList || showAllTrips !== this.state.showAllTrips){
      const themeListDefault = ['beach','city','jungle','racing','food'];
      const themeList = [];
      for(const theme of themeListDefault){
        if (this.getTripsByTheme(theme, tripsToShow).length > 0){

          // Apply default filter

          // Default filter for off-roading only
          if (theme === 'racing'){
            let newTrips = this.getTripsByTheme(theme, tripsToShow);
            if (sortFilters[3].sortFunc) {
              newTrips = newTrips.sort(sortFilters[3].sortFunc);
            }

            themeList.push({
              theme: theme,
              totalThemeTrips: newTrips.length,
              trips:  showAllTrips || newTrips.length <= initialTripsToShow ? [...newTrips] : newTrips.slice(0, initialTripsToShow),
              sortFilter: sortFilters[3]
            });
          }
          // Other theme default filter
          else{
            let newTrips = this.getTripsByTheme(theme, tripsToShow);
            if (sortFilter.sortFunc) {
              newTrips = newTrips.sort(sortFilter.sortFunc);
            }

            themeList.push({
              theme: theme,
              totalThemeTrips: newTrips.length,
              trips:  showAllTrips || newTrips.length <= initialTripsToShow ? [...newTrips] : newTrips.slice(0, initialTripsToShow),
              sortFilter: sortFilter
            });
          }
        }
      }

      // Store all trips, themes & selectedTheme
      let selectedTheme = ((themeList.length) ? themeList[0].theme : themeListDefault[0]);
      if (!this.state.themeList && themeList.length || showAllTrips !== this.state.showAllTrips){
        this.setState({ themeList: themeList, showAllTrips: showAllTrips, selectedTheme: selectedTheme});
      }

      // themeList = [...new Set(tripsToShow.map(trip => trip.theme))];
      // console.log(sortFilter);
      // console.log('themeList', this.state.themeList);
      // for(const theme of themeList){
      //   console.log('theme', theme);
      //   console.log(this.getTripsByTheme(theme, tripsToShow));
      // }

      // if (sortFilter.sortFunc) {
      //   tripsToShow = tripsToShow.sort(sortFilter.sortFunc);
      // }
    }

    if (vehicleFilter !== 'All vehicles') {
      tripsToShow = tripsToShow.filter(
        trip =>
          trip.recommended_vehicle.model === vehicleFilter ||
          trip.is_own_vehicle
      );
    }

    if (error) {
      console.log(error);
      return (
        <div className='container'>
          <ErrorDisplay error={error} />
        </div>
      );
    }

    if (tripsLoading) {
      return <LottieLoader />;
    }

    if (blank) {
      return (
        <div
          style={{
            height: '100vh',
            width: '100vw',
            zIndex: 1030,
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: 'white'
          }}
        />
      );
    }

    return (
      <div className='fe-home fe-under-header-effect'>
        <Helmet>
          <title>{SITE_TITLE}</title>
        </Helmet>

        {showPopUp ? <TripPopUp trips={(this.state.selectedTheme) ? this.state.themeList.find(theme => theme.theme === this.state.selectedTheme).trips : tripsToShow} /> : null}
        <div className='fe-home-video-container'>
          <div className='container fe-home-video-header'>
            <img src={fordLogoWhite} alt='' />
            {/* <img src={landingIconMobile} className="fe-home-landing-icon mobile" alt='' /> */}
            <div className='fe-home-video-controls'>
              {/* <ScrollLink
                                to="trip-listing"
                                offset={-90}
                                duration={500}
                                smooth={true}
                            >
                                <Button
                                    onClick={null}
                                >
                                    {t('home:browse')}
                                </Button>
                            </ScrollLink> */}
              {/* <Button onClick={this.handleVideoButtonClick.bind(this)}>
                {t('home:watch')}
              </Button> */}
            </div>
          </div>
          {/* <video autoPlay loop muted playsInline className='fe-home-video'>
            <source src='/videos/fordVideo041522.mp4' type='video/mp4' />
          </video> */}
          <BannerCarousel />
        </div>

        <div className='fe-home-step-banner'>
          <img className='fe-home-step-banner-image desktop' src={stepBanner} alt=''/>
          <img className='fe-home-step-banner-image' src={mobileStepBanner} alt=''/>
          {/* <div className='container'>
            <div className='fe-home-step-banner-text'>
              <div className='text1'>
                Ready for an adventure?
              </div>
              <div className='text2'>
                Join a Ford Ranger Getaway in 3 easy steps:
              </div>
            </div>
            <div className='fe-home-step-banner-images'>
              <div className='fe-home-banner-image-div'>
                <img src={step1} alt=''/>
                <div className='fe-home-step-banner-step-number'>1</div>
              </div>
              <div className='fe-home-banner-image-div'>
                <img src={step2} alt=''/>
                <div className='fe-home-step-banner-step-number'>2</div>
              </div>
              <div className='fe-home-banner-image-div'>
                <img src={step3} alt=''/>
                <div className='fe-home-step-banner-step-number'>3</div>
              </div>
            </div>
          </div> */}
        </div>

        <FeaturedPromo />

        <section className='fe-theme-menu-section'>
          <div className='container'>
            <h3 className='fe-home-subheading'>{t('home:fordRangerExperiences')}</h3>
            <div className='fe-theme-menu-wrapper'>
              <div className='fe-theme-menu-fade-layer'>
              </div>
              <div className='fe-theme-menu' ref={(themeScrollDOM) => { this.themeScrollDOM = themeScrollDOM; }}>
                { (this.state.themeList || []).length > 0 ? (
                  (this.state.themeList || []).map((theme, i) => (
                    <button
                      key={theme.theme}
                      className={`fe-theme-menu-button ${ theme.theme === this.state.selectedTheme ? 'selected' : ''}`}
                      onClick={() => {this.setState({selectedTheme: theme.theme}); this.handleThemeClick(i);}}
                      ref={(themeDOM) => { this['themeDOM'+i] = themeDOM; }}
                    >
                      <img src={this.getThemeIcon(theme.theme, this.state.selectedTheme)} alt='' />
                      <span>{t(`gen:${theme.theme}`)}</span>
                    </button>
                  ))) : null
                }
              </div>
              <div className='fe-filter-menu'>
                <button onClick={this.toggleFilter} className={`fe-filter-button ${(this.state.isShowMenu)? 'show-menu' : ''}`} ref={(buttonDOM) => { this.buttonDOM = buttonDOM; }}>
                  <img src={downArrowIcon} alt='Arrow Icon' className='fe-filter-arrow-icon' />
                  <div className='fe-filter-dropdown-div'>
                    <div className='fe-filter-dropdown-button' onClick={this.handleChildClick}>
                      <input className='fe-filter-dropdown-radio' onChange={() => this.handleChangeFilter('lowToHigh', this.state.selectedTheme)} checked={this.checkCurrentFilter('lowToHigh')} type="radio" id="lowToHigh" name="lowToHigh"/>
                      <label className='fe-filter-dropdown-label' onClick={() => this.handleChangeFilter('lowToHigh', this.state.selectedTheme)}>
                        Price
                        <img src={smallArrowUp} alt='Arrow Up' />
                      </label><br/>
                    </div>
                    <div className='fe-filter-dropdown-button' onClick={this.handleChildClick}>
                      <input className='fe-filter-dropdown-radio' onChange={() => {this.handleChangeFilter('highToLow', this.state.selectedTheme);}} checked={this.checkCurrentFilter('highToLow')} type="radio" id="highToLow" name="highToLow"/>
                      <label className='fe-filter-dropdown-label' onClick={() => {this.handleChangeFilter('highToLow', this.state.selectedTheme);}} >
                        Price
                        <img src={smallArrowDown} alt='Arrow Down' />
                      </label><br/>
                    </div>
                    <div className='fe-filter-dropdown-button' onClick={this.handleChildClick}>
                      <input className='fe-filter-dropdown-radio' onChange={() => this.handleChangeFilter('state', this.state.selectedTheme)} checked={this.checkCurrentFilter('state')} type="radio" id="fistatelter" name="state"/>
                      <label className='fe-filter-dropdown-label' onClick={() => this.handleChangeFilter('state', this.state.selectedTheme)}>By State</label>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* <section className='fe-trip-vehicle-filters'>
          <div className='container'>
            <header className='fe-trip-vehicle-filters-header'>
              <h3 className='fe-home-subheading'>{t('home:pickRanger')}</h3>
            </header>

            <div className='fe-vehicle-filters-container'>
              {vehicleFilters.map((vehicle, idx) => (
                <VehicleFilter
                  key={idx}
                  image={vehicle.img_url}
                  name={vehicle.name}
                  desc={vehicles[vehicle.name]}
                />
              ))}
            </div>
          </div>
        </section> */}

        { (this.state.themeList || []).length > 0 ? (
          (this.state.themeList || []).map((theme) => (
            (theme.theme === this.state.selectedTheme) ?
              (
                <section className='fe-trip-listing' id='trip-listing' key={theme.theme}>
                  <div className='container'>
                    {/* <header className='fe-trip-listing-header'>
                      <h3 className='fe-home-subheading'>{t(`gen:${theme.theme}`)}</h3> */}
                    {/* <div className='fe-trip-sort-filters'>
                      <Dropdown
                        options={sortFilters.map(filter => t(`home:${filter.name}`))}
                        optionValues={sortFilters.map(filter => filter.name)}
                        value={theme.sortFilter.name}
                        onChange={val => this.handleChangeFilter(val, theme.theme)}
                      />
                    </div> */}
                    {/* </header> */}
                    <div className='row no-gutters'>
                      {theme.trips.length > 0 ?
                        (
                          theme.trips.map(trip => (
                            <div key={trip.id} className='col-xl-3 col-sm-6 col-12'>
                              <NewTripItem
                                trip={trip} handleClick={() => {this.setState({selectedTheme: theme.theme});}}
                                startDate={(trip.date_available)? trip.date_available[0]: trip.date_available}
                              />
                            </div>
                          ))
                        ) : (
                          <div className='col fe-trip-listing-msg'>
                            {t('gen:noSearchResults')}
                          </div>
                        )}
                      {tripsLoadingMore ? <LoadingSpinner /> : null}
                    </div>
                    <div className='fe-trip-listing-notes'>
                      {/* {hasBYOR ? (
                        <p className='fe-trip-listing-note'>
                          <img
                            className='fe-trip-listing-legend'
                            src={iconBYOC}
                            alt=''
                          />
                          <span>{t('gen:byocNote')}</span>
                        </p>
                      ) : null} */}
                      <PriceNotes />
                    </div>
                  </div>
                </section>
              ) : null
          ))
        ) : (
          <div className='col fe-trip-listing-msg'>
            {t('gen:noSearchResults')}
          </div>
        )}

        {(pastExperiences.length > 0) ? (
          <section className='fe-past-experiences'>
            <div className='container'>
              <h3 className='fe-home-subheading'>Past Experiences</h3>
            </div>

            <div>
              <Slider
                onInit={() => {
                  this.isSliderInitial = true;
                }}
                ref={slider => (this.slider = slider)}
                dots = {false}
                infinite = {true}
                slidesToShow = {1}
                slidesToScroll = {1}
                autoplay = {true}
                speed = {10000}
                autoplaySpeed = {0}
                cssEase = 'linear'
                centerMode = {true}
                variableWidth = {true}
                // centerPadding = '60px'
                swipeToSlide = {true}
                pauseOnHover = {true}
              >
                {pastExperiences.map((experience, y) => {
                  return (
                    <div key = {y} className='fe-past-experiences-card'>
                      <a className='fe-past-experiences-hyperlink' href={experience.url} target='_blank' rel='noopener noreferrer'>
                        <img className='fe-past-experiences-img' src={experience.img_url.desktop} />
                      </a>
                    </div>
                  );
                })}
                {/* <div className='fe-past-experiences-card'>
                  <a className='fe-past-experiences-hyperlink' href=''>
                    <img className='fe-past-experiences-img' src="https://shopstg.sdacford.com.my/images/reviews/20/bs2h97ks8.jpeg" />
                  </a>
                </div>
                <div className='fe-past-experiences-card'>
                  <a className='fe-past-experiences-hyperlink' href=''>
                    <img className='fe-past-experiences-img' src="https://shopstg.sdacford.com.my/images/reviews/19/ih86p95mf.jpeg" />
                  </a>
                </div>
                <div className='fe-past-experiences-card'>
                  <a className='fe-past-experiences-hyperlink' href=''>
                    <img className='fe-past-experiences-img' src="https://shopstg.sdacford.com.my/images/reviews/12/3b3kksq5d.jpeg" />
                  </a>
                </div>
                <div className='fe-past-experiences-card'>
                  <a className='fe-past-experiences-hyperlink' href=''>
                    <img className='fe-past-experiences-img' src="https://shopstg.sdacford.com.my/images/reviews/21/268z6oe3v.jpeg" />
                  </a>
                </div>
                <div className='fe-past-experiences-card'>
                  <a className='fe-past-experiences-hyperlink' href=''>
                    <img className='fe-past-experiences-img' src="https://shopstg.sdacford.com.my/images/reviews/23/ycrzr62k4.png" />
                  </a>
                </div>
                <div className='fe-past-experiences-card'>
                  <a className='fe-past-experiences-hyperlink' href=''>
                    <img className='fe-past-experiences-img' src="https://shopstg.sdacford.com.my/images/reviews/26/kn8p115o8.png" />
                  </a>
                </div> */}
              </Slider>
            </div>

          </section>
        ) : null}

        <TileStories />

        <section className='fe-home-desc'>
          <div className='container'>
            <div className='row justify-content-lg-center'>
              <div className='col-lg-12'>
                <a
                  href='/getaways/our-story'
                  style={{ textDecoration: 'none' }}
                >
                  <div className='fe-home-desc-container'>
                    {/* <img src={fordLogoWhiteSmaller} alt='' />
                    <p
                      dangerouslySetInnerHTML={{ __html: t('home:expDesc1') }}
                    />
                    <p
                      dangerouslySetInnerHTML={{ __html: t('home:expDesc2') }}
                    />
                    <p
                      dangerouslySetInnerHTML={{ __html: t('home:expDesc3') }}
                    />
                    <p
                      dangerouslySetInnerHTML={{ __html: t('home:expDesc4') }}
                    />
                    <Button alt className='explore-our-story-white'>
                      Explore Our Story
                    </Button> */}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

Home.propTypes = {
  trips: PropTypes.array.isRequired,
  totalTrips: PropTypes.number.isRequired,
  tripsLoading: PropTypes.bool.isRequired,
  tripsLoadingMore: PropTypes.bool.isRequired,
  tripsOffset: PropTypes.number.isRequired,
  tripsLimit: PropTypes.number.isRequired,
  error: PropTypes.object,
  showPopUp: PropTypes.bool.isRequired,
  pastExperiences: PropTypes.array.isRequired,
  fetchPastExperiences: PropTypes.func.isRequired,
  fetchTrips: PropTypes.func.isRequired,
  fetchAdditionalTrips: PropTypes.func.isRequired,
  toggleActiveTripPopUp: PropTypes.func.isRequired,
  vehicleFilter: PropTypes.string.isRequired,
  sortFilter: PropTypes.object.isRequired,
  toggleShowAllTrips: PropTypes.func.isRequired,
  showAllTrips: PropTypes.bool.isRequired,
  setLightboxVideo: PropTypes.func.isRequired,
  setSortFilter: PropTypes.func.isRequired,
  toggleLightbox: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  videoSrc: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  hasBYOC: PropTypes.bool.isRequired,
  hasBYOR: PropTypes.bool.isRequired,
  redirect: PropTypes.bool,
  authType: PropTypes.string
};

const mapStateToProps = ({
  tripState,
  pastExperiencesState,
  apiState,
  lightboxState,
  authState
}) => ({
  trips: tripState.trips,
  totalTrips: tripState.totalTrips,
  tripsLoading: tripState.loading,
  tripsLoadingMore: tripState.loadingMore,
  tripsOffset: tripState.offset,
  tripsLimit: tripState.limit,
  pastExperiences: pastExperiencesState.pastExperiences,
  showPopUp: tripState.showPopUp,
  showAllTrips: tripState.showAllTrips,
  vehicleFilter: tripState.vehicleFilter,
  sortFilter: tripState.sortFilter,
  videoSrc: lightboxState.videoSrc,
  error: apiState.error,
  hasBYOC: tripState.hasBYOC,
  hasBYOR: tripState.hasBYOR,
  redirect: authState.redirect,
  authType: authState.authType
});

const mapDispatchToProps = {
  fetchPastExperiences,
  fetchTrips,
  fetchAdditionalTrips,
  toggleActiveTripPopUp,
  clearApiError,
  toggleShowAllTrips,
  setSortFilter,
  setLightboxVideo,
  toggleLightbox,
  resetSelectByor
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Home)
);
